import React from "react";
import { Typography, CircularProgress, Grid, ListItem, List, ListItemText, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { UserDetailsDTO } from "@beable/roster-backend-client-v1";
import {
  ClassListItem,
  OrganizationDTO,
} from "@beable/roster-backend-client-v1";
import { getUserDetailsStyles } from "./styles";

export interface UserDetailsProps {
  userDetails: UserDetailsDTO | undefined;
  isLoading: boolean;
  topOffset?: number;
  orgs?: OrganizationDTO[];
  isAdmin?: boolean;
}

export default function UserDetails(props: UserDetailsProps) {
  const theme = useTheme();
  const styles = getUserDetailsStyles(theme, props.topOffset);

  return (
    <Box sx={styles.dynamicMargin}>
      <Typography variant="h4">User Details</Typography>
      {props.isLoading ? (
        <Box sx={styles.loaderContainer}>
          <CircularProgress disableShrink />
        </Box>
      ) : null}
      {!props.isLoading && props.userDetails && (
        <Box>
          <Typography variant="body1">
            Name: {props.userDetails.firstName} {props.userDetails.lastName}
          </Typography>
          <Typography variant="body1">
            Status: {props.userDetails.internalStatus}
          </Typography>
          <Typography variant="body1">
            Username: {props.userDetails.username}
          </Typography>
          {!props.isAdmin && (
            <Typography variant="body1">
              Grade: {props.userDetails.grade || "N/A"}
            </Typography>
          )}
          <Typography variant="body1">
            External Id: {props.userDetails.externalSourceId}
          </Typography>
          {Array.isArray(props.userDetails.classes) && props.userDetails.classes.length > 0 && (
            <Grid
              size={{
                xs: 12,
                md: 6
              }}>
              <Typography variant="body1">Classes:</Typography>
              <div>
                <List dense>
                  {props.userDetails.classes.map((cls: ClassListItem) => {
                    return (
                      <ListItem key={cls.id} divider dense>
                        <ListItemText primary={cls.name} />
                      </ListItem>
                    );
                  })}
                </List>
              </div>
            </Grid>
          )}
          {Array.isArray(props.orgs) && props.orgs.length > 0 && (
            <Grid
              size={{
                xs: 12,
                md: 6
              }}>
              <Typography variant="body1">Orgs:</Typography>
              <div>
                <List dense>
                  {props.orgs.map((org: OrganizationDTO) => {
                    return (
                      <ListItem key={org.id} divider dense>
                        <ListItemText primary={org.name} />
                      </ListItem>
                    );
                  })}
                </List>
              </div>
            </Grid>
          )}
        </Box>
      )}
    </Box>
  );
}
